import 'babel-polyfill'
import 'react-hot-loader/patch'
import './orionx-logo'
import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import './styles'
import {AppContainer} from 'react-hot-loader'
import * as Sentry from '@sentry/browser'

Sentry.init({
  dsn: 'https://33112dedbb46449c9f167f2c57a85af3@o167618.ingest.sentry.io/1241721',
  tracesSampleRate: 0.01
})

if (localStorage.getItem('Meteor.userId')) {
  Sentry.setUser({
    id: localStorage.getItem('Meteor.userId')
  })
}

ReactDOM.render(
  <AppContainer>
    <App />
  </AppContainer>,
  document.getElementById('root')
)

// Hot Module Replacement API
if (module.hot) {
  module.hot.accept('./App', () => {
    const NextApp = require('./App').default
    ReactDOM.render(
      <AppContainer>
        <NextApp />
      </AppContainer>,
      document.getElementById('root')
    )
  })
}



// WEBPACK FOOTER //
// ./src/index.js